import { combineReducers } from "@reduxjs/toolkit";
import { serverApi } from "../services/RestService";
import { oldServerApi } from "../services/RestService";
import { ordersApi } from "../services/RestService";
import mobileNavBarReducer from './slices/MobileNavBarSlice';
import InsertProductSelectedProductTypeReducer from './slices/InsertProductSelectedProductTypeSlice';
import ArticleModalStatusReducer from './slices/ArticleModalStatusSlice';

const reducers = combineReducers({
    mobileNavBar: mobileNavBarReducer,
    selectedProduct: InsertProductSelectedProductTypeReducer,
    articlesModalStatus: ArticleModalStatusReducer,
    [oldServerApi.reducerPath]: oldServerApi.reducer,
    [serverApi.reducerPath]: serverApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer
});

export default reducers;
